function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeometricalShapes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.3499998 6.3500004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#d7d7d7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.172074
    },
    width: 2.1611018,
    height: 2.1611018,
    x: 4.2033877,
    y: 0.64296734
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.195544
    },
    cx: 1.3041043,
    cy: 2.4956911,
    rx: 1.289063,
    ry: 1.3117853
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.228871
    },
    d: "M 4.9498917,5.4798189 3.3369907,5.5122118 1.7240896,5.4798189 2.5061627,3.8561916 3.3369907,2.2649572 4.1678186,3.8561915 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeometricalShapes);
export default __webpack_public_path__ + "static/media/GeometricalShapes.f7a2e38d.svg";
export { ForwardRef as ReactComponent };